import API from "../../../lib/API";

export const installationMemberService = {
  getMembers: async () => {
    try {
      const response = await API.get("/installation-members");
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getMemberById: async (id) => {
    try {
      const response = await API.get(`/installation-members/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  createMember: async (data) => {
    try {
      const response = await API.post("/installation-members", data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  updateMember: async (id, data) => {
    try {
      const response = await API.put(`/installation-members/${id}`, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  deleteMember: async (id) => {
    try {
      const response = await API.delete(`/installation-members/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};
